import { render, staticRenderFns } from "./TimetableGantt.vue?vue&type=template&id=0f450fef&"
import script from "./TimetableGantt.vue?vue&type=script&lang=js&"
export * from "./TimetableGantt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports